import type { PriorityValue } from './types.tsx';

export const transformValue = (value: PriorityValue) => {
	if (!value) {
		return [];
	}
	const valuesArray = Array.isArray(value) ? value : [value];
	return valuesArray.map(({ name }) => ({
		value: name,
		label: name,
	}));
};
